/** @format */

import React, {useState} from "react";
import { FadeLoader } from "react-spinners";
import FellowLayout from "views/fellows/Fellow";
import ProviderLayout from "views/providers/Provider";
import { useGetZohoSupportTicketsQuery } from "store/services/adminAPI";
import SupportTicketsTable from "./components/SupportTicketsTable";
import { getLocalStorage } from "utils/secure";
import { ReactComponent as AllTicketsIcon } from "images/svg/all-tickets.svg";
import { ReactComponent as OpenTicketsIcon } from "images/svg/open-tickets.svg";
import { ReactComponent as ClosedTicketsIcon } from "images/svg/closed-tickets.svg";
import { ReactComponent as PencilIcon } from "images/svg/pencil.svg";
import Select from "react-select";
import { selectStyles } from "./components/selectStyles";
import { SubmissionModal } from "./components/SubmissionModal";

const user = localStorage.getItem("3MTUSER")
  ? getLocalStorage("3MTUSER")
  : null;

const userRole = user?.account_type;

const FilterOptions = [
  { value: "desc", label: "Newest to Oldest" },
  { value: "asc", label: "Oldest to Newest" },
];

const SupportPage = () => {
  const [showSubmissionModal, setShowSubmissionModal] = useState(false);
  const [activeTab, setActiveTab] = useState('all');
  const [filterString, setFilterString] = useState('');
  const [selectedSort, setSort] = useState(FilterOptions[0]);

  const { data, isLoading, isFetching } = useGetZohoSupportTicketsQuery(filterString);

  const handleSort = (selectedOption) => {
    setSort(selectedOption);
    setFilterString(`sort=${selectedOption.value}`);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    
    let statusParam = '';
    if (tab === 'open') {
      statusParam = 'status=Open';
      setFilterString(statusParam);
    } else if (tab === 'closed') { 
      statusParam = 'status=Closed';
      setFilterString(statusParam);
    } else { 
      statusParam = '';
      setFilterString(statusParam); 
    }
  };

  const renderContent = (LayoutComponent) => (
    <LayoutComponent>
      <div className="row">
        <div className="file-navigation-container">
          <div className="support-tabs-container">
            <button 
              className={`tab-button ${activeTab === 'all' ? 'active' : ''}`}
              onClick={() => handleTabClick('all')}
            >
              <AllTicketsIcon className="mr-2"/>
              All
            </button>
            
            <button 
              className={`tab-button ${activeTab === 'open' ? 'active' : ''}`}
              onClick={() => handleTabClick('open')}
            >
              <OpenTicketsIcon className="mr-2"/>
              Open
            </button>
            
            <button 
              className={`tab-button ${activeTab === 'closed' ? 'active' : ''}`}
              onClick={() => handleTabClick('closed')}
            >
              <ClosedTicketsIcon className="mr-2"/>
              Closed
            </button>
          </div>
      
          <div className="actions-container">
            <div className="sort-dropdown">
              <Select
                value={selectedSort}
                onChange={handleSort}
                options={FilterOptions}
                styles={selectStyles}
                components={{
                  IndicatorSeparator: () => null
                }}
              />
            </div>
            
            <button 
              className="report-issue-button" 
              onClick={() => setShowSubmissionModal(true)}
            >
              <PencilIcon className="mr-2" />
              Report an Issue
            </button>
          </div>
        </div>

        {isLoading || isFetching ? (
          <div className="d-flex justify-content-center align-items-center height-15 bg-white">
            <FadeLoader color="#36d7b7" />
          </div>
        ) : (
          <div>
            <SupportTicketsTable
              tickets={data?.data}
              isLoading={isLoading}
              metadata={data?.data?.metadata}
            />
          </div>
        )}
      </div>
    </LayoutComponent>
  );

  return (
    <div>
      <SubmissionModal
        setShowSubmissionModal={setShowSubmissionModal}
        handleCloseSubmissionModal={() => setShowSubmissionModal(false)}
        showSubmissionModal={showSubmissionModal}
      />
      
      {userRole === "FELLOW" && renderContent(FellowLayout)}
      {userRole === "PROVIDER" && renderContent(ProviderLayout)}
    </div>
  );
};

export default SupportPage;